import { createContext } from 'react';
import { PaywallActionDiscounts } from './action-discounts';

interface AddonContextValue {
  action: PaywallActionDiscounts | null;
}

export const AddonContext = createContext<AddonContextValue>({
  action: null,
});
